import { Directive, HostListener } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[processoMask]',
})
export class ProcessoMaskDirective {
  constructor(private control: NgControl) {}

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text')?.trim() || ''
    // Formato completo SIGAD: XX-P-XXXXX/YYYY ou XX-D-XXXXX/YYYY
    const match = pasted.match(/^\d{2}-[A-Za-z]-(\d+\/\d{4})$/)
    if (match) {
      event.preventDefault()
      this.control.control?.setValue(match[1])
    }
  }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const raw = event.target.value.replace(/\D/g, '') // only digits
    const length = raw.length

    let formatted = ''
    if (length <= 4) {
      formatted = '/' + raw
    } else {
      const year = raw.slice(-4)
      const number = raw.slice(0, -4)
      formatted = number + '/' + year
    }

    this.control.control?.setValue(formatted, { emitEvent: false })
  }
}
